"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { ScrollArea } from "@base-ui/react/scroll-area";
import { cn } from "../../utils/index.js";
import { scrollAreaVariants } from "./ScrollArea.variants.js";
function ScrollArea_ScrollArea({ children, className, headerNode, slots = {
    root: '',
    viewport: '',
    content: '',
    scrollbar: '',
    thumb: ''
}, ...props }) {
    const { root, viewport, content, scrollbar, thumb } = scrollAreaVariants(props);
    const rootClasses = cn(root(), className ?? slots.root);
    const viewportClasses = cn(viewport(), slots.viewport);
    const contentClasses = cn(content(), slots.content);
    const scrollbarClasses = cn(scrollbar(), slots.scrollbar);
    const thumbClasses = cn(thumb(), slots.thumb);
    return /*#__PURE__*/ jsxs(ScrollArea.Root, {
        className: rootClasses,
        children: [
            /*#__PURE__*/ jsxs(ScrollArea.Viewport, {
                tabIndex: 0,
                className: viewportClasses,
                children: [
                    headerNode,
                    /*#__PURE__*/ jsx("div", {
                        className: contentClasses,
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ jsx(ScrollArea.Scrollbar, {
                className: scrollbarClasses,
                children: /*#__PURE__*/ jsx(ScrollArea.Thumb, {
                    className: thumbClasses
                })
            })
        ]
    });
}
export { ScrollArea_ScrollArea as ScrollArea };
